export const getProjectNavigationPath = (caseId, isValidator = false) => {
  const normalizedCaseId = String(caseId ?? '').trim();
  if (!normalizedCaseId) {
    return isValidator ? '/validate' : '/';
  }

  const basePath = isValidator ? '/validate' : '/case';
  return `${basePath}/${encodeURIComponent(normalizedCaseId)}`;
};
